import { Injectable } from '@angular/core'
import { createStore, withProps } from '@ngneat/elf'
import { LoaderService } from './loader.service'
import { Product, ProductGQL } from '../gql/generated'
import { tap } from 'rxjs/operators'
import { Observable } from 'rxjs'

// interface ProductState {
//   item: Product | null
// }

// const initialState: ProductState = {
//   item: null,
// }

@Injectable({
  providedIn: 'root',
})
export class ProductDetailsService {
  productStore$ = createStore(
    { name: 'product' },
    withProps<Product | null>(null)
  )
  constructor(
    private productGQL: ProductGQL,
    private loaderService: LoaderService
  ) {}

  fetchProduct(slug: string) {
    return this.loaderService.withLoader(() => {
      return this.productGQL.fetch(
        { slug },
        {
          context: {
            headers: {
              'vendure-token': 'K7',
            },
          },
          fetchPolicy: 'network-only',
        }
      ).pipe(
        tap({
          next: (response) => {
            const product = (response.data.product as Product) || {}
            this.productStore$.update(() => ({
              ...product,
            }))
          },
          error: (error) => {
            console.error('Failed to fetch products:', error)
          },

          complete: () => {
            console.log('complete')
          },
        })
      )
    }, 'PRODUCT')
  }

  getLoaderState(loaderName: string): Observable<boolean> {
    return this.loaderService.getLoaderState(loaderName)
  }
}
